import { faDownload, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createDownloadDocumentUrl } from 'API/order/documents/adminDocumentsAPI';
import { downloadDocument } from 'API/order/documents/downloadDocument';
import React from 'react';
import styled from 'styled-components';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { Button, TinyBodyText, Tooltip } from 'ui-toolkit';
import { PDFPreview } from 'ui-toolkit/components/PDFPreview';
import { DocumentUploaded } from './DocumentUploaded';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export interface IDocumentDetailsProps {
  categories: IDocumentCategory[];
  pdfPreviewData?: IStandardDocumentVersionData;
  onClose: () => void;
  onRemove?: (documentId: string) => void;
}

const DangerDelete = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.error};
`;

export const DocumentDetails: React.FC<IDocumentDetailsProps> = ({ categories, onClose, onRemove, pdfPreviewData }) => {
  const category = categories.find((t) => t.name === pdfPreviewData?.category);

  const onClick = () => {
    downloadDocument(pdfPreviewData!.id, pdfPreviewData!.versionId, pdfPreviewData!.fileName);
  };

  return (
    <div className={'grid gap-1'}>
      {pdfPreviewData && (
        <>
          <div className={'flex flex-row items-center'}>
            <Button
              className={'p-2'}
              type={'button'}
              isInline
              intent={'ghost'}
              data-test-id={'download-document'}
              onClick={onClick}
            >
              <Tooltip tooltipContent={'Download'} trigger={'hover'} placement={'bottom'}>
                <FontAwesomeIcon icon={faDownload} style={{ padding: '6px' }} />
              </Tooltip>
            </Button>
            <Tooltip tooltipContent={`Preview PDF: ${pdfPreviewData.fileName}`} trigger={'hover'}>
              <TinyBodyText className={'max-w-md overflow-hidden text-ellipsis pl-2'}>
                {pdfPreviewData.fileName}
              </TinyBodyText>
            </Tooltip>
            <TinyBodyText className={'flex-grow basis-2/6 p-2'}>{category?.label}</TinyBodyText>

            {pdfPreviewData.metadata?.good_through_date && (
              <TinyBodyText className={'basis-1/6 p-2'}>
                {/** This is expiration instead of good thru to not cause confusion with the good thru date above in the fee fields */}
                <div>Expiration:</div>
                <div>{getDateString('M/d/yyyy', pdfPreviewData.metadata.good_through_date)}</div>
              </TinyBodyText>
            )}
            <TinyBodyText className={'basis-1/6 p-2'}>
              <DocumentUploaded document={pdfPreviewData} />
            </TinyBodyText>
            {onRemove && (
              <TinyBodyText className={'p-2'}>
                <Button
                  intent={'ghost'}
                  data-test-id={'remove-document'}
                  isInline
                  onClick={() => onRemove(pdfPreviewData.id)}
                >
                  <DangerDelete icon={faTrashCan} />
                </Button>
              </TinyBodyText>
            )}
          </div>
          <PDFPreview
            file={createDownloadDocumentUrl(pdfPreviewData.id, pdfPreviewData.versionId)}
            onClose={onClose}
            previewStyle={'card'}
          />
        </>
      )}
    </div>
  );
};
